module.exports = __webpack_public_path__ + "static/media/process-flow-6-icon.a0ecbeb1.svg";